import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import VersionHistory from 'src/components/common/VersionHistory';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { archLevel } from 'src/data/config';
import { useLazyGetSysAdminNewCodelistQuery } from 'src/services/workarea';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import IMVFollowupLetter from './IMVFollowupLetter';
import { DataTable } from '@pihealth/common-ui-library';
import staticData from '../../../../resources/static.json';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
const DataGridFollowUp: React.FunctionComponent<any> = (props: any) => {
  const { lettersListBackOn, setLettersListBackOn } = props;
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [viewIMVFollowUpGrid, setViewIMVFollowUpGrid] = useState(true);
  const [openFollowupLetter, setOpenFollowupLetter] = useState(false);
  const [letterData, setLetterData] = useState<any>([]);
  const [showVersionHistory, setShowVersionHistory] = useState<boolean>(false);
  const [headerTitle, setHedertitle] = useState('');
  const [docId, setDocId] = useState('');
  const dispatch = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const imvFollowupReviewCode = 'IMVFUL';
  const [originalReviewedItems, setOriginalReviewdItems] = useState<any>([]);
  const handleBack = (isFormChanged = false) => {
    if (!lettersListBackOn) {
      props.setFollowUp(false);
      props.setStudyLogOpen(true);
    } else {
      if (isFormChanged) {
        setOpenConfirmExit(true);
      } else {
        setLettersListBackOn(false);
        setOpenFollowupLetter(false);
        setViewIMVFollowUpGrid(true);
      }
    }
  };
  const handleClickFollowupLetter = async (letterRecord: any) => {
    if (archLevel === 'site' && checkPermission('view_published_imvfollowupletter')) {
      if (letterRecord?.major_version >= '1.0') {
        setLetterData(letterRecord);
        setLettersListBackOn(true);
        setViewIMVFollowUpGrid(false);
        setOpenFollowupLetter(true);
      } else {
        dispatch(setMessage({ msgDetails: `${letterRecord?.visit_name} not yet Published`, severity: 'error' }));
      }
    } else {
      if (!isHierarchyLevelClosed) {
        setLettersListBackOn(true);
        setViewIMVFollowUpGrid(false);
        setOpenFollowupLetter(true);
        setLetterData(letterRecord);
      } else {
        dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
      }
    }
  };
  const handleVersionHistory = (row: any) => {
    setHedertitle(row.visit_name);
    setDocId(row?.tp_document_id);
    setShowVersionHistory(true);
  };
  const actions = {
    visit_name: (data: any) => {
      handleClickFollowupLetter(data);
    },
    major_version: (data: any) => {
      handleVersionHistory(data);
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`Conduct Interim Monitoring Visit Follow-Up`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const [getCodeListCode] = useLazyGetSysAdminNewCodelistQuery();
  const getReviewCodeListData = async () => {
    const codes: any = await getCodeListCode(imvFollowupReviewCode);
    if (codes?.isSuccess) {
      setOriginalReviewdItems(codes.data);
    } else if (codes?.isError) {
      dispatch(setMessage({ msgDetails: 'Error fetching reviewed items', severity: 'error' }));
    }
  };
  useEffect(() => {
    getReviewCodeListData();
  }, []);
  return (
    <div>
      <Box className="mainBackBtnWrap">
        <Button startIcon={<ArrowBackIcon fontSize="small" />} onClick={() => handleBack(isChanged)}>
          {!lettersListBackOn ? 'List of Logs' : 'Back'}
        </Button>
      </Box>
      {viewIMVFollowUpGrid ? (
        <DataTable
          columns={staticData.imvChecklist.columns}
          rows={props.rows}
          loading={props.isLoading}
          actions={actions}
          datePreference={userPreferedDateFormat}
          className="studylogDatagrid"
          exportAll
          height="74vh"
          hasDefinedDataGridToolbarExport
          definedGridToolbarExport={definedCustomDatGridExport}
        />
      ) : openFollowupLetter ? (
        <IMVFollowupLetter
          setOpenFollowupLetter={setOpenFollowupLetter}
          setViewIMVFollowUpGrid={setViewIMVFollowUpGrid}
          letterData={letterData}
          setLettersListBackOn={setLettersListBackOn}
          isChanged={isChanged}
          setIsChanged={setIsChanged}
          openConfirmExit={openConfirmExit}
          setOpenConfirmExit={setOpenConfirmExit}
          siteStudyPersonnelsData={props.siteStudyPersonnelsData}
          handleBack={handleBack}
          originalReviewedItems={originalReviewedItems}
        />
      ) : null}
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'IMV FOLLOWUP'}
        />
      ) : (
        ''
      )}
    </div>
  );
};
export default DataGridFollowUp;
